import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/all';

gsap.registerPlugin(ScrollTrigger);

export default {
  init($element) {

  },
  finalize($element) {

    // Animate in left to right, bearing in mind the CTAs are split in half
    const section = $('.upper-section').get();

    // Mobile top half
    const mobileTop = $element.find('.upper-section .cta-top-half').get();

    gsap.fromTo(mobileTop, {
      top: '20px',
      opacity: 0,
    }, {
      top: 0,
      opacity: 1,
      duration: 0.6,
      scrollTrigger: {
        trigger: section,
        start: 'top 40%',
      },
    });

    // Top half
    $element.find('.upper-section .cta-row .col-12').each(function(i) {
      const thisItem = $(this).get();

      gsap.fromTo(thisItem, {
        top: '20px',
        opacity: 0,
      }, {
        top: 0,
        opacity: 1,
        duration: 0.6,
        delay: (i * 0.3),
        scrollTrigger: {
          trigger: section,
          start: 'top 40%',
        },
      });
    });

    // Bottom half
    $element.find('.lower-section .cta-row .col-12').each(function(i) {
      const thisItem = $(this).get();

      gsap.fromTo(thisItem, {
        top: '20px',
        opacity: 0,
      }, {
        top: 0,
        opacity: 1,
        duration: 0.6,
        delay: (i * 0.3),
        scrollTrigger: {
          trigger: section,
          start: 'top 40%',
        },
      });
    })

  },
}


// WEBPACK FOOTER //
// ./scripts/partials/shared/threeColumnCta.js